export default function EmptyState({ icon: Icon, heading, description, action, className = "" }) {
  return (
    <div className={`surface py-12 text-center ${className}`}>
      {Icon && (
        <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
          <Icon className="w-10 h-10 text-muted-foreground" />
        </div>
      )}
      <h3 className="text-lg font-medium mb-1">{heading}</h3>
      {description && (
        <p className="text-muted-foreground mb-4">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
